import React, { Component } from 'react';
import { GetText, SearchList } from '../config/helper';
import { Container, InputGroup, FormControl, Tab, Nav, Card } from 'react-bootstrap';
import { FaMagnifyingGlass, FaArrowDown } from 'react-icons/fa6';
import LibraryBlock from '../inc/library/Block';
import LibraryList from '../inc/library/List';
import Loading from '../inc/Loading';
import TagHeaders from '../inc/Headers';
import '../config/global';

const authKey = global.config.kindcode.training[1]+global.config.authBearerKey;

export default class LibraryBrowseMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      libraryList: [],
      libraryFeatured: [],
      libraryCategories: [],
      isLoad: false
    }
  }

  componentDidMount() {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly"}';
    var dataSend = JSON.parse(dataText);

    fetch(global.config.urlLink+"/librarylist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }, 
      body : JSON.stringify(dataSend)
    })
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    })
    .then(resultJson => {
      var resultData = [];
      var inum=0;
      var libraryDataList = resultJson.values;
      if(global.config.specialCategory !== undefined && global.config.specialCategory.length > 0) {
        libraryDataList = resultJson.values.filter(libdata => {
          // Return true to keep the item, so we check if 'some' in excludeObjects is FALSE
          return !global.config.specialCategory.some(excludeItem => 
              excludeItem.value === libdata.content.categoryName 
          );
        });  
      } 
      
      for (var i in libraryDataList) {
        var content = libraryDataList[i].content;
          content.id = libraryDataList[i].docid;
          resultData.push(content);
          if (this.state.libraryCategories.indexOf(content.categoryName) < 0) {
            this.state.libraryCategories.push(content.categoryName);
          }
          inum++;
          if(inum === libraryDataList.length) {
            this.setState({
              libraryList: resultData,
              isLoad: true
            });
          }
      }
    });
  }

  render() {
    return (
      <div className="browse-library">
        <TagHeaders value={
								{	
									docid: '', 
									title: 'Library', 
									description: '',
									links: global.config.urlHost+'/libraries'
								}
							}/>
        {
          this.state.libraryList.length > 0 ? (
            <>
            <section>
              <Container>
                <h1 className="mb-4">Library</h1>
                <p className="mb-5">{GetText() ? "Library Novaio Academy menyediakan berbagai materi pembelajaran yang dirancang untuk memperkuat digital skill dan profesionalitas di berbagai bidang. Akses yang mudah dan fleksibel mendukung perkembangan berkelanjutan dan kesiapan karier." : "Novaio Academy Library provides a variety of learning materials designed to strengthen digital skills and professionalism in various fields. Easy and flexible access supports continuous development and career readiness."}</p>
                <div className="separator mt-0"><div className="icon"><FaArrowDown className="bg2-secondary" /></div></div>
              </Container>
            </section>
            <section>
              <Container>
                <h3>{GetText() ? "Library Terbaru" : "Latest Libraries"}</h3>
                <div className="row py-4 mb-5">
                  {
                    this.state.libraryList
                    .sort((a, b) => b.createDate._seconds - a.createDate._seconds)
                    .slice(0,4)
                    .map((libraryItem, i) => {
                      return (
                        <div className="col-md-3" key={i}>
                          <LibraryBlock value={libraryItem}/>
                        </div>
                      )
                    })
                  }
                </div>
              </Container>
              <div className="separator mt-0"><div className="icon"><FaArrowDown className="bg2-secondary" /></div></div>
            </section>
            </>
          ) : this.state.isLoad === true? (
            <div className="mt-5 mb-5">
              <div style={{height:"100px"}}></div>
              <div className="d-flex align-items-center justify-content-center">
                <Card className='card-pop'>
                  <Card.Body className="text-center">
                    <h1 className="mb-4" style={{fontSize:"50pt", color:"#DC3545"}}>COMING SOON</h1>
                    <p style={{fontSize:"13pt", color:"#595959"}}>{GetText() ?  `Tetaplah bersama kami. Hal yang menarik akan segera hadir. \nJadilah yang pertama mengetahuinya.` : `Stay tuned. Something awesome is coming soon. \nBe the first to know.` } </p>
                  </Card.Body>
                </Card>
              </div>
              <div style={{height:"200px"}}></div>
            </div>
          ) : <Loading value={{id:'library-area', type: 'screen'}}/> 
        }
        {
          this.state.libraryCategories.length > 0 ? (
            <section>
              <Container>
                <div className="row py-4">
                  <Tab.Container defaultActiveKey="category-all">
                    <div className="col-md-3">
                      <div className="sidebar-tab sticky-top">
                        <h3 className="mb-4">{GetText() ? "Pencarian" : "Search"}</h3>
                        <InputGroup className="mb-5">
                          <FormControl
                            placeholder={GetText() ? "Ketik di sini..." : "Type here..."}
                            aria-label="Library"
                            aria-describedby="search"
                            id="search"
                            onKeyUp={SearchList}
                         />
                          {/* <InputGroup.Append> */}
                            <InputGroup.Text><FaMagnifyingGlass/></InputGroup.Text>
                          {/* </InputGroup.Append> */}
                        </InputGroup>
                        <h3 className="mb-4">{GetText() ? "Kategori" : "Category"}</h3>
                        <Nav variant="pills" className="nav-scroll flex-column">
                          <Nav.Item key="all">
                            <Nav.Link eventKey="category-all">{GetText() ? "Semua" : "All"}</Nav.Link>
                          </Nav.Item>
                          {
                            this.state.libraryCategories
                            .sort((a, b) => { return (a < b) ? -1 : ((a > b) ? 1 : 0) })
                            .map((libraryCategory, i) => {
                              return (
                                <Nav.Item key={i}>
                                  <Nav.Link eventKey={"category-" + i}>{libraryCategory}</Nav.Link>
                                </Nav.Item>
                              )
                            })
                          }
                        </Nav>
                      </div>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-8 bg-light p-5 br-8">
                      <h3 className="mb-4">{GetText() ? "Daftar Library" : "Library List"}</h3>
                      <Tab.Content>
                        <Tab.Pane eventKey="category-all" key="all">
                          {
                            this.state.libraryList
                            .sort((a, b) => b.createDate._seconds - a.createDate._seconds)
                            .map((libraryItem, i) => {
                              return (
                                <LibraryList value={libraryItem} key={i}/>
                              )
                            })
                          }
                        </Tab.Pane>
                        {
                          this.state.libraryCategories
                          .sort((a, b) => { return (a < b) ? -1 : ((a > b) ? 1 : 0) })
                          .map((libraryCategory, i) => {
                            return (
                              <Tab.Pane eventKey={"category-" + i} key={i}>
                                {
                                  this.state.libraryList
                                  .sort((a, b) => b.createDate._seconds - a.createDate._seconds)
                                  .filter(libraryItem => libraryItem.categoryName === libraryCategory)
                                  .map((libraryItem, j) => {
                                    return (
                                      <LibraryList value={libraryItem} key={j}/>
                                    )
                                  })
                                }
                              </Tab.Pane>
                            )
                          })
                        }
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
              </Container>
            </section>
          ) : ''
        }
      </div>
    );
  }
}